import createIcon from '@/lib/create-icon'

const TrendingIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
    <path
      d='M14.5 7.45215L11.2898 10.7009C10.8693 11.1264 10.1718 11.09 9.79792 10.6231L9.39804 10.1238C9.0256 9.65872 8.33168 9.62047 7.91038 10.0418L5.5 12.4521M14.5 7.45215H12.25M14.5 7.45215V9.59501M5 19H15C17.2091 19 19 17.2091 19 15V5C19 2.79086 17.2091 1 15 1H5C2.79086 1 1 2.79086 1 5V15C1 17.2091 2.79086 19 5 19Z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'TrendingIcon'
)

export default TrendingIcon
